// extracted by mini-css-extract-plugin
export default {"content":"AuditTable_content__nwnuq"};